import { useState, useEffect } from 'react';
import { reviewsService } from '../services/reviewsService';

export const useSavedManagers = () => {
  const [savedManagers, setSavedManagers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastKey, setLastKey] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchSavedManagers = async (isInitial = false) => {
    try {
      setIsLoading(true);
      setError(null);
      
      const currentLastKey = isInitial ? null : lastKey;
      const response = await reviewsService.getUserSavedManagers(currentLastKey);
      
      if (isInitial) {
        setSavedManagers(response.items || []);
      } else {
        setSavedManagers(prev => [...prev, ...(response.items || [])]);
      }
      
      setLastKey(response.last_key || null);
      setHasMore(!!response.last_key);
    } catch (err) {
      setError(err.message || 'Failed to fetch saved managers');
      console.error('Error fetching saved managers:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMore = () => {
    if (!isLoading && hasMore && lastKey) {
      fetchSavedManagers(false);
    }
  };

  const refresh = () => {
    setSavedManagers([]);
    setLastKey(null);
    setHasMore(true);
    fetchSavedManagers(true);
  };

  useEffect(() => {
    fetchSavedManagers(true);
  }, []);

  return {
    savedManagers,
    isLoading,
    error,
    hasMore,
    loadMore,
    refresh
  };
};
